<template>
  <div id="devis">
    <Title :titlePage="titlePage" />
    <v-container fluid class="pa-4 pb-0">

      <div class="filter-bar">
        <v-text-field
          v-model="search"
          placeholder="Rechercher un client..."
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          hide-details
          clearable
          class="filter-search"
          @input="onSearchInput"
          @click:clear="onSearchClear"
        />
        <div class="filter-chips">
          <button
            class="filter-chip"
            :class="{ active: statusFilter.length === 0 }"
            @click="statusFilter = []"
          >Tous</button>
          <button
            class="filter-chip filter-chip--red"
            :class="{ active: statusFilter.includes('A relancer') }"
            @click="toggleFilter('A relancer')"
          >A relancer</button>
          <button
            class="filter-chip filter-chip--green"
            :class="{ active: statusFilter.includes('En attente') }"
            @click="toggleFilter('En attente')"
          >En attente</button>
          <button
            class="filter-chip filter-chip--blue"
            :class="{ active: statusFilter.includes('Nouvelle relance') }"
            @click="toggleFilter('Nouvelle relance')"
          >Nouvelle relance</button>
        </div>
      </div>

      <resultList
        :header="headerDevis"
        :items="devis"
        :nbResult="nbDisplay"
        :type="'devis'"
        @sort="sort"
        :totalItems="totalItems"
        :page="page"
        height="calc(87vh - 175px)"
        @emitPopupDevis="openDevisOverlay"
      />
      <div v-if="totalPages > 1" class="pagination-bar">
        <button class="page-btn" :disabled="page === 1" @click="page--">
          <v-icon small>mdi-chevron-left</v-icon>
        </button>
        <span class="page-info">Page {{ page }} / {{ totalPages }}</span>
        <button class="page-btn" :disabled="page === totalPages" @click="page++">
          <v-icon small>mdi-chevron-right</v-icon>
        </button>
      </div>
    </v-container>

    <DevisOverlay
      :numero_devis="numeroDevis"
      :dialog="dialog"
      text="Configuration devis"
      actions=""
      heightProp=""
      widthProp="70vW"
      showClose="true"
      @emitDialog="closeDevis"
      @emitSaved="onDevisSaved"
    />
  </div>
</template>

<script>
import api from "@/api/user.js";
import ResultList from "@/components/shared/ResultList";
import Title from "@/components/shared/Title";
import DevisOverlay from "@/components/Devis/devisOverlay";

export default {
  name: "Devis",
  components: { Title, ResultList, DevisOverlay },
  data() {
    return {
      titlePage: "Devis en cours",
      dialog: false,
      devis: [],
      totalItems: 0,
      totalPages: 0,
      page: 1,
      column: "date_devis",
      order: "DESC",
      search: "",
      statusFilter: [],
      numeroDevis: 0,
      nbDisplay: process.env.VUE_APP_NB_DISPLAY,
      searchTimeout: null,
      headerDevis: [
        { text: "CLIENT",       align: "center", sortable: true,  value: "raison_sociale" },
        { text: "N° DEVIS",     align: "center", sortable: false, value: "numero_devis" },
        { text: "MONTANT",      align: "center", sortable: false, value: "montant" },
        { text: "DATE",         align: "center", sortable: true,  value: "date_devis" },
        { text: "TYPOLOGIE",    align: "center", sortable: true,  value: "typologie" },
        { text: "STATUT",       align: "center", sortable: true,  value: "statut" },
      ],
    };
  },
  watch: {
    page() {
      this.getDevis();
    },
    statusFilter() {
      this.page = 1;
      this.getDevis();
    },
  },
  methods: {
    getDevis() {
      const id = this.$store.state.AsUser.id_utilisateur || "";
      api.getDevis(id, this.nbDisplay, this.page - 1, this.column, this.order, this.search || "", this.statusFilter).then((res) => {
        this.devis = res.data.devis.rows;
        this.totalItems = res.data.devis.totalItems;
        this.totalPages = res.data.devis.totalPages;
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors du chargement' });
      });
    },
    sort(sortEvent) {
      if (sortEvent.column !== undefined) {
        this.column = sortEvent.column === "Entreprise.raison_sociale"
          ? "raison_sociale"
          : sortEvent.column;
        this.page = sortEvent.page;
      }
      if (sortEvent.order !== undefined) {
        this.order = sortEvent.order ? "ASC" : "DESC";
      }
      this.getDevis();
    },
    toggleFilter(status) {
      const idx = this.statusFilter.indexOf(status);
      if (idx === -1) {
        this.statusFilter.push(status);
      } else {
        this.statusFilter.splice(idx, 1);
      }
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.page = 1;
        this.getDevis();
      }, 350);
    },
    onSearchClear() {
      this.search = "";
      this.page = 1;
      this.getDevis();
    },
    openDevisOverlay(numeroDevis) {
      this.numeroDevis = numeroDevis;
      this.dialog = true;
    },
    closeDevis(isOpen) {
      this.dialog = isOpen;
    },
    onDevisSaved(data) {
      if (data && data.actif === 0) {
        this.devis = this.devis.filter(d => d.numero_devis !== this.numeroDevis);
        return;
      }
      const statutMap = { 2: "En attente", 3: "Nouvelle relance" };
      const newStatut = data && statutMap[data.id_devis_statut];
      if (newStatut) {
        const row = this.devis.find(d => d.numero_devis === this.numeroDevis);
        if (row) { this.$set(row, 'statut', newStatut); }
      }
    },
  },
  created() {
    this.getDevis();
  },
};
</script>

<style scoped lang="scss">
#devis {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

// ── Filter bar ──────────────────────────────────────────────────────
.filter-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.filter-search {
  max-width: 280px;
}

.filter-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.filter-chip {
  padding: 4px 12px;
  border-radius: 20px;
  border: 1px solid #d0d0d0;
  background: #fff;
  font-size: 0.78rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  color: #555;

  &:hover {
    border-color: #0b87ba;
    color: #0b87ba;
  }

  &.active {
    background: #06445d;
    border-color: #06445d;
    color: #fff;
  }

  &--red.active  { background: #e53935; border-color: #e53935; }
  &--green.active { background: #43a047; border-color: #43a047; }
  &--blue.active  { background: #1e88e5; border-color: #1e88e5; }
}

// ── Pagination ──────────────────────────────────────────────────────
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 6px 0 2px;
}

.page-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  &:hover:not(:disabled) {
    background: #f0f0f0;
    border-color: #0b87ba;
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
}

.page-info {
  font-size: 0.82rem;
  color: #555;
  font-weight: 500;
  min-width: 90px;
  text-align: center;
}
</style>
